(function($){

    jQuery('a').smoothScroll({offset: -150});

    if(window.location.hash) {
        var hash = window.location.hash;

        jQuery('html, body').animate({
            scrollTop: jQuery(hash).offset().top - 150
        }, 800, 'swing');
    }


    // Refresh JazzHR iframe with search parameters.
    if ( $('#resumator-job-frame').length ) {
        // Query string example.
        // State needs to be uppercase.
        // ?form_id=advanced_search_jobs&s_title=XXXXX&s_state=MN

        var loc        = window.location.href;
        var params     = loc.split('?')[1];
        var iframe     = document.getElementById('resumator-job-frame');
        var iframe_src = iframe.src;

        // Update iframe src with parameters.
        if ( params ) {
            // Clear iframe source of any exising parameters, then append new params.
            iframe.src = iframe_src.split('?')[0] + '?' + params;

            // Scroll to iframe.
            $('html, body').animate({
                scrollTop: $(iframe).offset().top - 150
            }, 800, 'swing');

        }

        // Remove the query string from the browser URL.
        window.history.replaceState(null, null, window.location.pathname);
    }



})(jQuery);
